import {getUrlParams} from '@/utils/urlUtils';
import {QUERY, VIEW_TYPE} from './config';
import {openLinkByRuliu} from '@/utils/browserUtils';

// 暂时做仅展示文档区域逻辑 一切从简
export const isShowCurrentView = (view: string | null) => {
    const query = getUrlParams();
    if ([VIEW_TYPE.onlyContent, VIEW_TYPE.sideBar].includes(query?.[QUERY.view] as string)) {
        return false;
    }
    return true;
};


export const isSidebarView = () => {
    const query = getUrlParams();
    return VIEW_TYPE.sideBar === query?.[QUERY.view];
};


export const openLinkProxy = (url: string, ...argv: any[]) => {
    if (isSidebarView()) {
        openLinkByRuliu(url);
        return;
    }
    window.open(url, ...argv);
};

export const getViewMode = () => {
    const query = getUrlParams();
    if (!query?.[QUERY.view]) {
        return 'preview';
    }
    return query?.[QUERY.viewMode] === 'edit' ? 'edit' : 'preview';
};
